export default "__VITE_ASSET__CW05_JWq__"